import { useTranslation } from 'react-i18next'
import ImageProduct from '../../assets/images/Utilities/Illustration product.svg'
import ImageContainer from '../../assets/images/Utilities/Illustration_container.svg'
import ImageLooseProduct from '../../assets/images/Utilities/Illustration_single_product.svg'
import { AtlasBodyMain, AtlasBodyTitle, AtlasListAtom, CardComponent } from '@justomx/atlas-components'

export type TransferOptionSelected = 'move-products' | 'move-container' | 'move-loose-products'

interface MoveTypeDetail {
  img: string
  alt: string
  title: string
  items: string[]
}

interface MoveProductsSelectorMoleculeProps {
  type: TransferOptionSelected
  onClick: () => void
  items?: string[]
}

export const MoveProductsSelectorMolecule = ({
  type,
  onClick,
  items
}: MoveProductsSelectorMoleculeProps) => {
  const { t } = useTranslation('global')

  const MOVE_PARAMS: Record<TransferOptionSelected, Omit<MoveTypeDetail, 'items'>> = {
    'move-container': {
      img: ImageContainer,
      alt: 'Image showing how to move a container from a location',
      title: t('move-products-selector.move-container.title')
    },
    'move-products': {
      img: ImageProduct,
      alt: 'Image showing how to move a product to a location',
      title: t('move-products-selector.move-products.title')
    },
    'move-loose-products': {
      img: ImageLooseProduct,
      alt: 'Image showing how to move a loose product to a location',
      title: t('move-products-selector.move-loose-products.title')
    }
  }

  const defaultItems = t(`move-products-selector.${type}.items`, {
    returnObjects: true
  }) as string[]
  

  const params = MOVE_PARAMS[type]
  const listItems = items || defaultItems

  return (
    <CardComponent onClick={onClick}>
      <img src={params.img} alt={params.alt} />
      <AtlasBodyTitle>{params.title}</AtlasBodyTitle>
      <AtlasListAtom>
        {listItems.map((e, index) => (
          <li key={index}>
            <AtlasBodyMain display="contents">{e}</AtlasBodyMain>
          </li>
        ))}
      </AtlasListAtom>
    </CardComponent>
  )
}
